import React from "react";

const educationData = [
  {
    institution: "Excel Engineering College, Anna University",
    degree: "Master Of Computer Application",
    date: "March 2024",
    description:
      "Excel Engineering College provided a solid education and hands-on projects. I also learned various skills, including web development, app development, and more, through Udemy.",
    aosDelay: "100",
  },
  {
    institution:
      "St. Joseph's College of Arts and Science, Thiruvalluvar University",
    degree: "Bachelor Of Computer Application",
    date: "April 2022",
    description:
      "My time at St. Joseph's College was instrumental in building my technical foundation and fostering a love for continuous learning and innovation.",
    aosDelay: "200",
  },
  // {
  //   institution: "NLC Boys Higher Secondary School, Neyveli",
  //   degree: "10th and 12th",
  //   date: "April 2019",
  //   description:
  //     "At NLC Boys Higher Secondary School, I developed strong values, discipline, and a commitment to excellence that have guided me throughout my educational journey.",
  //   aosDelay: "300",
  // },
];

const experienceData = [
  {
    institution: "Sonata Software, Hyderabad",
    degree: "Digital Engineer",
    date: "Jun 2025 - Present",
    description:
      "At Sonata Software, I have delivered iOS features using Swift and designed intuitive user interfaces in Figma, contributing to smooth and timely product releases within an Agile environment. I improved UI workflows and overall code quality by streamlining development processes and enhancing feature implementation, ensuring a consistent and high-quality user experience across releases.",
    aosDelay: "300",
  },
  {
    institution: "Kirshi Technologies, Chennai",
    degree: "Software Developer",
    date: "Feb 2022 - May 2025",
    description:
      "At Kirshi Technologies, I have worked on Flutter, iOS, and blockchain projects, building mobile, web, and desktop applications with features like real-time communication, location services, and data synchronization. I have also contributed to a blockchain-based project using Hyperledger Fabric, expanding my expertise in secure and distributed systems. My work has been recognized by leadership, reinforcing the impact I have made in delivering high-quality solutions.",
    aosDelay: "400",
  },
];

const EducationItem = ({
  institution,
  degree,
  date,
  description,
  aosDelay,
}) => (
  <div data-aos="fade-down" data-aos-delay={aosDelay}>
    <h2>{institution}</h2>
    <h4>
      {degree} <span className="date">• {date}</span>
    </h4>
    <p dangerouslySetInnerHTML={{ __html: description }} />
  </div>
);

const ResumeDetailsItem = (props) => {
  return (
    <div className="row add_zindex">
      <div className="mb-4 col-lg-4 center-content" data-aos="fade-down">
        <h2 className="underline education__topic">{props.title}</h2>
      </div>
      <div className="col-lg-8 col-md-12 education__details">
        {props.data.map((item, index) => (
          <React.Fragment key={index}>
            <EducationItem
              institution={item.institution}
              degree={item.degree}
              date={item.date}
              description={item.description}
              aosDelay={item.aosDelay}
            />
            {index !== props.data.length - 1 ? <br /> : <></>}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

const Resume = () => {
  return (
    <div className="jumbotron1">
      <div id="Resume" className="first1"></div>
      <ResumeDetailsItem title="EXPERIENCE" data={experienceData} />
      <div className="row add_zindex" data-aos="fade-down" data-aos-delay="350">
        <hr className="divider_line" />
      </div>
      <ResumeDetailsItem title="EDUCATION" data={educationData} />
    </div>
  );
};

export default Resume;
